import React from "react";
import {
  CiCalendarDate,
  CiTimer,
  CiUser,
  CiMail,
  CiPhone,
  CiShoppingCart,
  CiForkAndKnife,
  CiDeliveryTruck,
  CiBellOn,
  CiCircleChevLeft,
  CiCircleChevRight,
  CiChat1,
  CiMoneyCheck1,
  CiCreditCard1,
  CiGlobe,
} from "react-icons/ci";
import { IoIosTimer } from "react-icons/io";
import ProcessingBar from "utils/Processingbar";
import Button from "components/Button";

const Summary = ({
  formData,
  totalAmount,
  onPlaceOrder,
  isProcessing,
  cart,
}) => {
  const orderingIcons = {
    pickup: <CiShoppingCart className="text-sm text-textGray" />,
    delivery: <CiDeliveryTruck className="text-sm text-textGray" />,
    table: <CiForkAndKnife className="text-sm text-textGray" />,
    "table-preorder": <CiBellOn className="text-sm text-textGray" />,
  };

  const paymentIcons = {
    cash: <CiMoneyCheck1 className="text-sm text-textGray" />,
    card: <CiCreditCard1 className="text-sm text-textGray" />,
    online: <CiGlobe className="text-sm text-textGray" />,
  };

  const groupedByOperator = cart.reduce((acc, item) => {
    const opId = item.operator;
    if (!acc[opId]) acc[opId] = { operatorInfo: item.operatorInfo, items: [] };
    acc[opId].items.push(item);
    return acc;
  }, {});

  return (
    <div className="space-y-6 ">
      {/* cart  */}
      <div className="max-h-[450px] flex-1 overflow-y-auto space-y-2 scrollbar-thin ">
        <div className="border border-border rounded-xl bg-dry p-3">
          {Object.values(groupedByOperator).map(({ operatorInfo, items }) => {
            if (!operatorInfo) return null;

            const subTotal = items.reduce(
              (sum, i) => sum + i.price * i.count,
              0
            );
            return (
              <div
                key={operatorInfo._id}
                className="space-y-6 rounded-xl bg-dry p-0 mb-3"
              >
                <div className="flex items-center space-x-4 cursor-pointer ">
                  <img
                    src={operatorInfo.photo || "/default-avatar.png"}
                    alt={operatorInfo.name || "Operator"}
                    className="w-16 h-16 rounded-full object-cover border border-neutral-300"
                  />
                  <div>
                    <p className="text-sm font-semibold">{operatorInfo.name}</p>
                    <p className="text-[12px] text-neutral-500 dark:text-textGray">
                      {operatorInfo.address}
                    </p>
                  </div>
                </div>

                <div className="space-y-3">
                  {items.map((item) => (
                    <div key={item._id} className="flex justify-between">
                      <div>
                        <p className="text-sm">{item.title}</p>
                        <p className="text-sm text-textGray">
                          {item.count} × ${item.price.toFixed(2)}
                        </p>
                      </div>
                      <p className="font-medium">
                        ${(item.count * item.price).toFixed(2)}
                      </p>
                    </div>
                  ))}
                </div>

                <div className="border-0 border-neutral-200 dark:border-neutral-700 pt-0 flex justify-between text-sm">
                  <span>Subtotal</span>
                  <span>${subTotal.toFixed(2)}</span>
                </div>
              </div>
            );
          })}

          {/* Total */}
          <div className="pt-3 border-t border-border flex justify-between text-lg font-bold ">
            <span>Total</span>
            <span>${totalAmount.toFixed(2)}</span>
          </div>
        </div>

        <div className="border border-border p-3 rounded-2xl mt-6 bg-dry">
          {/* Date/Time */}
          {formData.selectedDateTime && (
            <div className="space-y-1 text-sm text-neutral-700 dark:text-white flex items-center">
              <p className="capitalize text-textGray">
                • {formData.orderingMethod} : &nbsp;
              </p>
              <div className="flex items-center space-x-2">
                <CiCalendarDate />
                <span>
                  {new Date(formData.selectedDateTime).toLocaleDateString(
                    "en-NZ",
                    {
                      weekday: "long",
                      day: "numeric",
                      month: "long",
                    }
                  )}
                </span>
              </div>
              <div className="flex items-center space-x-2">
                &nbsp;
                <IoIosTimer />
                <span>
                  {new Date(formData.selectedDateTime).toLocaleTimeString(
                    "en-NZ",
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </span>
              </div>
            </div>
          )}

          {/* Payment Method */}
          {formData.paymentMethod && (
            <div className="text-sm space-y-1 text-white flex items-center">
              <p className=" text-textGray">• Payment : &nbsp;</p>
              <div className="flex items-center space-x-2 capitalize text">
                {paymentIcons[formData.paymentMethod]}
                <span>{formData.paymentMethod.replace("-", " ")}</span>
              </div>
            </div>
          )}

          {/* Contact Info */}
          <div className="text-sm space-y-1 text-white">
            <p className="text-textGray flex">
              {" "}
              • Contact : &nbsp;
              {formData.name && (
                <span className="flex items-start space-x-2 text-white">
                  {formData.name}
                </span>
              )}
            </p>

            {formData.email && formData.mobile && (
              <p className="flex items-start space-x-2 ml-5">
                {" "}
                <CiMail className="mt-1 text-text" />
                <span>{formData.email}</span>
                <CiPhone className="mt-1 text-text" />
                <span>{formData.mobile}</span>
              </p>
            )}
            {formData.message && (
              <p className="flex items-start space-x-2 text-textGray">
                • Mesesage : &nbsp;
                <CiChat1 className="mt-1 text-textGray" />
                <span className="text-white italic">"{formData.message}"</span>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
